import React, { useEffect, useState } from 'react'
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import { useAlert } from "react-alert";
import "./../home/index.css";


const DisabledUser = () => {
    const [users, setUsers] = useState([]);
    const alert = useAlert();

    useEffect(() => {
        fetch(process.env.REACT_APP_API_URL + "api/user/disableduserlist")
            .then((response) => response.json())
            .then((data) => {
                if (data.issuccessful == true) {
                    setUsers(data.users);

                }
            });

    }, [])

    return (
        <div>

            <table id="myTable" className="display table table-hover table-bordered" data-page-length='10'>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Role</th>
                        <th>Team</th>
                        <th>Status</th>
                        {/* <th>Action</th> */}
                    </tr>
                </thead>
                <tbody>
                    {users.map((user, index) => {

                        return (
                            <tr key={index}>
                                <td>{user.UserName}</td>
                                <td>{user.UserEmail}</td>
                                <td>{user.AppRole}</td>
                                <td>{user.UserTeam}</td>
                                <td id={"status-" + user.UserID}>
                                    {user.IsActive == 1 ? (
                                        'Active'
                                    ) : (
                                        'Disabled'
                                    )}
                                </td>
                                {/* <td className='d-flex' style={{ justifyContent: "space-around" }}>
                                    <PencilIcon style={{ width: '15px' }} data-id={user.UserID} />
                                    <UserMinusIcon style={{ width: '15px' }} className='delete-btn' data-id={user.UserID} />
                                </td> */}
                                {/* <td><button id={`delete-${user.UserID}`} className='issue-btn' data-id={user.UserID}>Delete</button></td> */}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    )
}

export default DisabledUser